import { Button, Modal, Icon, Divider, List, Spin } from "antd";
import axios from "axios";
import React, { Component } from "react";
import Moment from "react-moment";
import InfiniteScroll from "react-infinite-scroller";
import { Constant } from "../../../config";

class RevisionChangeLog extends Component {
  state = {
    createLog: [],
    editLog: [],
    countryList: [],
    loading: true,
    logsTotal: 0,
    logsPage: 1,
    hasMoreLogs: true,
  };

  async componentWillMount() {
    const { countryList, data } = this.props;

    // ? fetch changed log
    const changeLog = await this._fetchChangeLog(countryList, data.id);
    const createLog = changeLog["logs"].filter(
      (item) => item.event === "create"
    );
    const editLog = changeLog["logs"].filter((item) => item.event === "update");
    this.setState({
      createLog: createLog,
      editLog: editLog,
      loading: false,
      logsTotal: changeLog.total,
    });
  }

  _fetchChangeLog = async (
    cl,
    id,
    page = 1,
    limit = 5,
    filter = { order_by: "id", order: "asc" }
  ) => {
    const url = Constant.REVISION_PRICE_CHANGE_LOGS_API.replace("[id]", id);
    const opt = {
      url: url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
        ...filter,
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    let data = resp.data;
    for (const event of data["logs"]) {
      event.prices.forEach((p) => {
        const country = cl.find((c) => p.country_abbr === c.region_code);
        if (country) p.country_name = country.name;
      });
    }

    return data;
  };

  listRenderer(event) {
    if (!event || this.state.loading) {
      return null;
    }
    const results = [];

    for (const [index, row] of event["prices"].entries()) {
      const jsx = (
        <span key={index} style={{ margin: "4px 0" }}>
          <span style={{ marginRight: "8px" }}>
            {index + 1}. {row.country_name}
          </span>

          <span>
            {row.price_before.toFixed(4)} <Icon type="arrow-right" />{" "}
            {row.price_after.toFixed(4)}
          </span>
        </span>
      );
      results.push(jsx);
    }

    return results;
  }

  listUpdateLogRenderer() {
    if (this.state.editLog.length <= 0 || this.state.loading) {
      return null;
    }

    const results = [];
    for (const action of [...this.state.editLog, ...this.state.editLog]) {
      const jsx = (
        <div key={action.group_key}>
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">
              {action.created_date}
            </Moment>{" "}
            - Edit Revision{" "}
            <span style={{ fontWeight: "normal", color: "grey" }}>
              Edit {String(action.version_before).padStart(4, "0")}{" "}
            </span>
          </span>
          <div className="main-container">{this.listRenderer(action)}</div>
          <Divider />
        </div>
      );

      results.push(jsx);
    }

    return results;
  }

  handleInfiniteOnLoad = async () => {
    let { editLog } = this.state;
    const { countryList, data } = this.props;

    this.setState({
      loading: true,
    });
    if (editLog.length === this.state.logsTotal - 1) {
      this.setState({
        hasMoreLogs: false,
        loading: false,
      });
      return;
    }

    let { logsPage } = this.state;
    logsPage++;
    this.setState({
      logsPage,
    });
    const changeLog = await this._fetchChangeLog(
      countryList,
      data.id,
      logsPage
    );
    const updateLogs = changeLog["logs"].filter(
      (item) => item.event === "update"
    );
    editLog = editLog.concat(updateLogs);
    this.setState({
      editLog,
      loading: false,
    });
  };

  render() {
    const { onCancel, visible, name, editCb, fromTable, canEdit, viewMore } =
      this.props;
    const footers = [
      <Button key="cancel" onClick={onCancel}>
        Close
      </Button>,
    ];

    if (canEdit) {
      footers.push(
        <Button key="edit" onClick={editCb}>
          Edit Revision
        </Button>
      );
    }

    if (fromTable) {
      const jsx = (
        <Button key="detail" type="primary" onClick={viewMore}>
          View Full Details
        </Button>
      );

      footers.push(jsx);
    }

    return (
      <Modal
        className="revision-change-log"
        footer={footers}
        onCancel={onCancel}
        title={
          <span>
            <h3>
              {name} <span style={{ color: "grey" }}>Change Logs</span>{" "}
            </h3>
          </span>
        }
        visible={visible}
      >
        <div className="change-logs-container">
          <InfiniteScroll
            initialLoad={false}
            pageStart={0}
            loadMore={this.handleInfiniteOnLoad}
            hasMore={!this.state.loading && this.state.hasMoreLogs}
            useWindow={false}
          >
            <List>
              {this.state.createLog.map((log, index) => (
                <List.Item key={`logs-${index}`}>
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">
                      {log.created_date}
                    </Moment>{" "}
                    - Create Revision{" "}
                    <span style={{ fontWeight: "normal", color: "grey" }}>
                      {String(log.version_before).padStart(4, "0")}{" "}
                      <Icon type="arrow-right" />{" "}
                      {String(log.version_after).padStart(4, "0")}
                    </span>
                  </span>
                  <div className="main-container">{this.listRenderer(log)}</div>
                </List.Item>
              ))}
              {this.state.editLog.map((log, index) => (
                <List.Item key={`logs-${index + 1}`}>
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">
                      {log.created_date}
                    </Moment>{" "}
                    - Edit Revision{" "}
                    <span style={{ fontWeight: "normal", color: "grey" }}>
                      Edit {String(log.version_before).padStart(4, "0")}{" "}
                    </span>
                  </span>
                  <div className="main-container">{this.listRenderer(log)}</div>
                </List.Item>
              ))}
              {this.state.loading && this.state.hasMoreLogs && (
                <div className="logs-loading">
                  <Spin />
                </div>
              )}
            </List>
          </InfiniteScroll>
        </div>
        {/* {this.listUpdateLogRenderer()} */}
      </Modal>
    );
  }
}

export default RevisionChangeLog;



// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/Modals/RevisionChangeLog.js